<template>
    <section class="relative">
        <div class="section-large text-with-image container">
           
        <div class="deadline-illustration">
            <div class="narrow-text m-center">
            <h2>Conference overview</h2>
            <p>This year's theme takes inspiration from Manchester Met’s new Education Strategy, ‘Building a Transformational Active Learning Community’ and echoes the strategy’s commitment to developing a world leading, active learning community, which delivers a broad-based educational experience linked to graduate, employer, and societal needs.</p>
            <p>The conference will be a celebration of all things active, inclusive, and effective in learning and teaching at Manchester Met and will bring together staff from across our faculties, departments, wide-ranging discipline areas, and professional services – all of whom contribute to the fantastic learning experience that Man Met students receive. This conference welcomes diverse voices and will celebrate the diversity of the Manchester Metropolitan community in all forms. We warmly welcome collaborative contributions from staff and students; insights from our various university partners; and the experiences of staff in learning and teaching support roles. First-time conference presenters, e.g., Postgraduate Research Students (PGRs) engaged in teaching activities or pedagogical research are also encouraged to contribute.</p>
            <p>If you require any support with preparing a conference proposal or adjustments to enable you to fully engage with the conference day or sessions, please let us know via<b> utacpd@mmu.ac.uk</b>.</p>
                </div>
        </div>
             <div class="text-with-image-img"><img src="../assets/overview-image.svg" alt=""></div>
        </div>    
        <div class="hero-divider">
            <svg role="img" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
            </svg>
        </div> 
    </section> 
</template>

<script setup>

    import { ref } from 'vue'
    import { date } from 'quasar'

    let textDay = ref(0)
    let textHour = ref(0)
    let textMinute = ref(0)
    let textSecond = ref(0)

    const date1 = ref(new Date().getTime())
    const date2 = ref(new Date('march 31, 2023 11:59:00'))
    const unit = ref('months')

    const diff = ref(date.getDateDiff(date2.value, date1.value, unit.value))
    // `diff` is 34 (days)
  
    const countdown = () => {
        const countDate = ref(new Date('march 31, 2023 11:59:00').getTime());

        const now = ref(new Date().getTime())
        const gap = ref(countDate.value - now.value)

        const second = ref(1000)
        const minute = ref(second.value * 60)
        const hour = ref(minute.value * 60)
        const day = ref(hour.value * 24)

        textDay.value = Math.floor(gap.value / day.value)
        textHour.value = Math.floor((gap.value % day.value) / hour.value)
        textMinute.value = Math.floor((gap.value % hour.value) / minute.value)
        textSecond.value = Math.floor((gap.value % minute.value) / second.value)
    };

    countdown()

    setInterval(countdown, 1000);

</script>



